import { mapData } from "@/stuff/DataMapping";
import utils from "@/stuff/Utils";

export interface IBannerMessage {
    id: number;
    message: string;
    availableFrom: Date;
    availableTo: Date;
    supplier: boolean;
    buyer: boolean;
    created: Date;
    createdByUserID: number;
    lastUpdated: Date;
    lastUpdatedByUserID: number;
    deleted: Date;
    deletedByUserID: number;
}

export class BannerMessage implements IBannerMessage {

    constructor(data?: IBannerMessage) {
        if (data) this.update(data);
    }

    update(data: IBannerMessage): void {
        mapData(data, { root: () => this });
    }

    id: number = 0;
    message: string = "";
    availableFrom: Date = new Date(utils.emptyDateValue);
    availableTo: Date = new Date(utils.emptyDateValue);
    supplier: boolean = false;
    buyer: boolean = false;
    created: Date = new Date(utils.emptyDateValue);
    createdByUserID: number = 0;
    lastUpdated: Date = new Date(utils.emptyDateValue);
    lastUpdatedByUserID: number = 0;
    deleted: Date = new Date(utils.emptyDateValue);
    deletedByUserID: number = 0;

    get isNew(): boolean { return utils.isEmptyId(this.id); }
    get isDeleted(): boolean { return utils.hasDateValue(this.deleted); }

}